import React, { useState, useEffect } from 'react';
import './App.css';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { ThreeDots } from 'react-loader-spinner';

const itemsPerPage = parseInt(process.env.REACT_APP_ITEMS_PER_PAGE);

const fetchOptionsFromBitrix24 = async (id, setter) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BITRIX_WEBHOOK_URL}crm.deal.userfield.get`, { id });
    const data = response.data.result.LIST;
    const optionsFromApi = data.map(item => ({ value: item.ID.toString(), label: item.VALUE }));
    setter(optionsFromApi);
  } catch (error) {
    console.error(`Error fetching options with ID ${id}:`, error);
  }
};

const fetchResponsiblesFromBitrix24 = async (id, setter) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BITRIX_WEBHOOK_URL}user.get`, {
      filter: { ACTIVE: 'Y', UF_DEPARTMENT: [5, 7] },
    });
    const data = response.data.result;
    const optionsFromApi = data.map(item => ({ value: item.ID.toString(), label: item.NAME + " " + item.LAST_NAME }));
    setter(optionsFromApi);
  } catch (error) {
    console.error(`Error fetching options with ID ${id}:`, error);
  }
};

const fetchStagesFromBitrix24 = async (id, setter) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BITRIX_WEBHOOK_URL}crm.dealcategory.stage.list`, {
      id: id,
    });

    const data = response.data.result;
    const optionsFromApi = data.map(item => ({ value: item.STATUS_ID.toString(), label: item.NAME }));
    setter(optionsFromApi);

  } catch (error) {
    console.error(`Error fetching categories for id ${id}:`, error);
  }
};

const fetchCountryOptions = async (setter) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BITRIX_WEBHOOK_URL}crm.contact.userfield.get`, { id: 228 });
    const data = response.data.result.LIST;
    const optionsFromApi = data.map(item => ({ value: item.ID.toString(), label: item.VALUE }));
    setter(optionsFromApi);
  } catch (error) {
    console.error(`Error fetching country options:`, error);
  }
};



function App() {
  const [filteredDeals, setFilteredDeals] = useState([]);
  const [fetchedContacts, setFetchedContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [respFilter, setRespFilter] = useState([]);
  const [respOptions, setRespOptions] = useState([]);
  const [excludeResp, setExcludeResp] = useState(false);

  const [pipelineFilter, setPipelineFilter] = useState(0);
  const [pipelineOptions, setPipelineOptions] = useState([]);

  const [stageFilter, setStageFilter] = useState([]);
  const [stageOptions, setStageOptions] = useState([]);
  const [excludeStage, setExcludeStage] = useState(false);

  const [doctorFilter, setDoctorFilter] = useState([]);
  const [doctorOptions, setDoctorOptions] = useState([]);
  const [emptyDoctor, setEmptyDoctor] = useState(false);
  const [excludeDoctor, setExcludeDoctor] = useState(false);

  const [langFilter, setLangFilter] = useState([]);
  const [langOptions, setLangOptions] = useState([]);
  const [emptyLang, setEmptyLang] = useState(false);
  const [excludeLang, setExcludeLang] = useState(false);

  const [treatmentFilter, setTreatmentFilter] = useState([]);
  const [treatmentOptions, setTreatmentOptions] = useState([]);
  const [emptyTreatment, setEmptyTreatment] = useState(false);
  const [excludeTreatment, setExcludeTreatment] = useState(false);

  const [reasonFilter, setReasonFilter] = useState([]);
  const [reasonOptions, setReasonOptions] = useState([]);
  const [emptyReason, setEmptyReason] = useState(false);
  const [excludeReason, setExcludeReason] = useState(false);

  const [whatsappFilter, setWhatsappFilter] = useState([]);
  const [whatsappOptions, setWhatsappOptions] = useState([]);
  const [emptyWhatsapp, setEmptyWhatsapp] = useState(false);

  const [countryFilter, setCountryFilter] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [emptyCountry, setEmptyCountry] = useState(false);
  const [excludeCountry, setExcludeCountry] = useState(false);

  const [templateList, setTemplateList] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState('');
  const [templateValues, setTemplateValues] = useState(['']);
  const [mediaUrl, setMediaUrl] = useState('');

  const [bulkAssign, setBulkAssign] = useState(false);

  const fetchPipelineOptions = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BITRIX_WEBHOOK_URL}crm.dealcategory.list`);
      const data = response.data.result;

      // Normal pipeline'ları hazırla
      const optionsFromApi = data.map(item => ({
        value: item.ID,
        label: item.NAME
      }));

      // Ana pipeline'ı manuel olarak ekle
      const mainPipeline = { value: 0, label: "Treatment Sales" };

      setPipelineOptions([mainPipeline, ...optionsFromApi]);
    } catch (error) {
      console.error("Error fetching pipelines:", error);
    }
  };


  useEffect(() => {
    fetchResponsiblesFromBitrix24(null, setRespOptions);
    fetchPipelineOptions();
    fetchStagesFromBitrix24(0, setStageOptions);
    fetchOptionsFromBitrix24(510, setDoctorOptions);
    fetchOptionsFromBitrix24(1063, setLangOptions);
    fetchOptionsFromBitrix24(1077, setTreatmentOptions);
    fetchOptionsFromBitrix24(396, setReasonOptions);
    fetchOptionsFromBitrix24(2271, setWhatsappOptions);
    fetchCountryOptions(setCountryOptions);
  }, []);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_UPSENSE_API_URL}templates`);
        const data = await response.json();
        setTemplateList(data.templates);

        if (data.templates.length > 0) {
          setSelectedTemplateId(data.templates[0].gupshup_id);
        }
      } catch (error) {
        console.error("Error fetching templates:", error);
      }
    };

    fetchTemplates();
  }, []);

  const handleTemplateValueChange = (index, value) => {
    const updatedTemplateValues = [...templateValues];
    updatedTemplateValues[index] = value;
    setTemplateValues(updatedTemplateValues);
  };

  const paginatedDeals = filteredDeals.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleFilterApply = async () => {

    if (
      startDate.length === 0 &&
      endDate.length === 0 &&
      respFilter.length === 0 &&
      stageFilter.length === 0 &&
      doctorFilter.length === 0 &&
      langFilter.length === 0 &&
      treatmentFilter.length === 0 &&
      reasonFilter.length === 0 &&
      whatsappFilter.length === 0 &&
      countryFilter.length === 0
    ) {
      alert("Please select at least one filter.");
      return;
    }
    setLoading(true);
    try {
      const filters = {
        "CATEGORY_ID": pipelineFilter,
        "UF_CRM_1646910708": [3117, 4161, null]

      };

      // Date Range
      if (startDate) { filters[">=DATE_CREATE"] = startDate; }
      if (endDate) {
        const endDateTime = new Date(endDate);
        endDateTime.setHours(23, 59, 59, 999);
        filters["<=DATE_CREATE"] = endDateTime.toISOString();
      }

      // Responsible
      if (respFilter.length > 0) {
        const key = excludeResp ? "!ASSIGNED_BY_ID" : "ASSIGNED_BY_ID";
        filters[key] = respFilter;
      }

      // Stage
      if (stageFilter.length > 0) {
        const key = excludeStage ? "!STAGE_ID" : "STAGE_ID";
        filters[key] = stageFilter;
      }

      // Doctor
      if (emptyDoctor) {
        filters["UF_CRM_1614780869409"] = [null, ""];
      } else if (doctorFilter.length > 0) {
        const key = excludeDoctor ? "!UF_CRM_1614780869409" : "UF_CRM_1614780869409";
        filters[key] = doctorFilter;
      }

      // Language
      if (emptyLang) {
        filters["UF_CRM_1645705625"] = [null, ""];
      } else if (langFilter.length > 0) {
        const key = excludeLang ? "!UF_CRM_1645705625" : "UF_CRM_1645705625";
        filters[key] = langFilter;
      }

      // Treatment
      if (emptyTreatment) {
        filters["UF_CRM_1646137196"] = [null, ""];
      } else if (treatmentFilter.length > 0) {
        const key = excludeTreatment ? "!UF_CRM_1646137196" : "UF_CRM_1646137196";
        filters[key] = treatmentFilter;
      }

      // Reason
      if (emptyReason) {
        filters["UF_CRM_1610457905592"] = [null, ""];
      } else if (reasonFilter.length > 0) {
        const key = excludeReason ? "!UF_CRM_1610457905592" : "UF_CRM_1610457905592";
        filters[key] = reasonFilter;
      }

      if (emptyWhatsapp) {
        filters["UF_CRM_1746721942"] = [null, ""];
      } else if (whatsappFilter.length > 0) {
        filters["UF_CRM_1746721942"] = whatsappFilter;
      }

      let start = 0;
      let allDeals = [];

      while (true) {
        const response = await axios.post(`${process.env.REACT_APP_BITRIX_WEBHOOK_URL}crm.deal.list`, {
          select: ["*", "UF_*"],
          filter: filters,
          start
        });
        let deals = response.data.result;

        deals.sort((a, b) => new Date(b.DATE_CREATE) - new Date(a.DATE_CREATE));

        allDeals = [...allDeals, ...deals];

        if (deals.length < 50) {
          break;
        }

        start += 50;
      }

      if (allDeals.length === 0) {
        setFilteredDeals([]);
        setFetchedContacts([]);
        setLoading(false);
        return;
      }

      let contactIds = allDeals.map(deal => deal.CONTACT_ID).filter(id => id);

      let startC = 0;
      let allContacts = [];

      while (true) {
        let contactFilters = { ID: contactIds };
        if (emptyCountry) {
          contactFilters["UF_CRM_1591879765"] = [null, ""];
        } else if (countryFilter.length > 0) {
          const key = excludeCountry ? "!UF_CRM_1591879765" : "UF_CRM_1591879765";
          contactFilters[key] = countryFilter;
        }
        const contactResponse = await axios.post(`${process.env.REACT_APP_BITRIX_WEBHOOK_URL}crm.contact.list`, {
          select: ["*", "UF_*", "PHONE", "EMAIL"],
          filter: contactFilters,
          start: startC
        });
        const contacts = contactResponse.data.result;
        allContacts = [...allContacts, ...contacts];
        if (contacts.length < 50) {
          break;
        }
        startC += 50;
      }

      const contactIdsSet = new Set(allContacts.map(contact => contact.ID));
      const filteredDealsByContacts = allDeals.filter(deal => contactIdsSet.has(deal.CONTACT_ID));

      setFilteredDeals(filteredDealsByContacts);
      setFetchedContacts(allContacts);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const sendMessageToAll = async () => {
    setLoading(true);
    try {
      const responses = await Promise.all(
        filteredDeals.map(async (deal, index) => {
          const contact = fetchedContacts.find(contact => contact.ID === deal.CONTACT_ID);
          const destination = contact && contact.PHONE && contact.PHONE.length > 0 ? contact.PHONE[0].VALUE : '';
          const userResponse = await axios.get('https://upsense-chat-prod-a5erbbece3cbbpan.spaincentral-01.azurewebsites.net/api/users');
          const users = userResponse.data.users;
          const user = users.find(u => String(u.bitrix_id) === String(deal.ASSIGNED_BY_ID));
          const messageId = await sendMessage(destination, deal.ID, user.id);
          return { dealId: deal.ID, messageId };
        })
      );
      toast.success("All messages have been sent successfully!");

      const messageIdMap = {};
      responses.forEach(({ dealId, messageId }) => {
        messageIdMap[dealId] = { messageId, status: 'Pending' }; // İlk olarak 'Pending' olarak ayarla
      });
    } catch (error) {
      console.error('Error sending messages:', error);
      toast.error("An error occurred while sending messages.");
    } finally {
      setLoading(false);
    }
  };

  const sendMessage = async (destination, dealId, userId) => {
    try {
      const selectedTemplate = templateList.find(template => template.gupshup_id === selectedTemplateId);
      if (!selectedTemplate) {
        console.error("Selected template not found");
        return;
      }

      const isMediaTemplate = ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(selectedTemplate.template_type);
      const params = templateValues.filter(value => value && value.trim() !== '');

      const requestBody = {
        phone_number: destination,
        message_type_name: selectedTemplate.template_type.toLowerCase(),
        message_category: "template",
        sender_source: "902127068151",
        receiver_destination: destination,
        assigned_user_id: userId,
        template: {
          id: selectedTemplateId,
          params: params
        }
      };

      if (isMediaTemplate && mediaUrl) {
        requestBody.url = mediaUrl;
      }


      const response = await fetch(`${process.env.REACT_APP_UPSENSE_API_URL}messages/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
      });

      const data = await response.json();
      // Response başarılı değilse hata logla
      if (!response.ok) {
        console.error("Message send failed:", {
          status: response.status,
          statusText: response.statusText,
          response: data,
          requestBody: requestBody,
          destination: destination,
          dealId: dealId
        });
        return null;
      }

      console.log("Message sent successfully:", {
        destination: destination,
        dealId: dealId,
        response: data
      });

      return data.messageId || data.id; // API response yapısına göre ayarlanabilir

    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const assignDealsToResponsibles = async () => {
    if (!bulkAssign || respFilter.length === 0) return;

    const batchSize = 50;
    let queueIndex = 0;

    const chunkArray = (arr, size) => {
      return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
        arr.slice(i * size, i * size + size)
      );
    };

    const dealChunks = chunkArray(filteredDeals, batchSize);

    for (const chunk of dealChunks) {
      const commands = {};

      for (let i = 0; i < chunk.length; i++) {
        const deal = chunk[i];
        const responsibleId = respFilter[queueIndex % respFilter.length].value;
        const responsibleName = respOptions.find(option => option.value === responsibleId)?.label || '';
        queueIndex++;

        const customFields = {
          UF_CRM_1645096392: responsibleId,
          UF_CRM_1670679541: responsibleName,
          UF_CRM_1696595707: 3899,
          UF_CRM_1696595601: responsibleId
        };

        const encodeFields = (fields) => {
          return Object.entries(fields)
            .map(([key, value]) => `FIELDS[${key}]=${encodeURIComponent(value)}`)
            .join("&");
        };

        const dealKey = `dealUpdate_${i}`;
        const contactKey = `contactUpdate_${i}`;

        const dealFieldsStr = `FIELDS[ASSIGNED_BY_ID]=${responsibleId}&${encodeFields(customFields)}`;
        const contactFieldsStr = `FIELDS[ASSIGNED_BY_ID]=${responsibleId}`;

        commands[dealKey] = `crm.deal.update?ID=${deal.ID}&${dealFieldsStr}`;
        commands[contactKey] = `crm.contact.update?ID=${deal.CONTACT_ID}&${contactFieldsStr}`;
      }

      try {
        await axios.post(`${process.env.REACT_APP_BITRIX_WEBHOOK_URL}batch`, {
          cmd: commands
        });
      } catch (error) {
        console.error("Batch işlem hatası:", error);
      }
    }
  };

  const clearFilters = () => {
    setStartDate('');
    setEndDate('');
    setRespFilter([]);
    setStageFilter([]);
    setDoctorFilter([]);
    setLangFilter([]);
    setTreatmentFilter([]);
    setReasonFilter([]);
    setWhatsappFilter([]);
    setCountryFilter([]);
    setFilteredDeals([]);
    setFetchedContacts([]);
    setExcludeStage(false);
    setExcludeReason(false);
    setExcludeResp(false);
    setExcludeDoctor(false);
    setExcludeLang(false);
    setExcludeTreatment(false);
    setExcludeCountry(false);
  };

  const templateOptions = templateList.map((template) => ({
    value: template.gupshup_id,
    label: template.element_name
  }));

  const selectedTemplate = templateList.find(template => template.gupshup_id === selectedTemplateId);

  const getParameterCount = (template) => {
    if (!template || !template.content) return 0;
    const matches = template.content.match(/{{\d+}}/g);
    return matches ? matches.length : 0;
  };

  const parameterCount = selectedTemplate ? getParameterCount(selectedTemplate) : 0;


  return (
    <div className="App">
      <ToastContainer />
      <div className="header">
        <img src={require("./logo.png")} alt="Clinic Wise" className="logo" />
      </div>
      <div className="container">
        <div className="filters-container">
          <div className="filters">
            <label>Start Date:</label>
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
            <label>End Date:</label>
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />

            <hr className="separator" />

            <label>Pipeline:</label>
            <Select
              options={pipelineOptions}
              value={pipelineOptions.find(option => option.value === pipelineFilter)}
              onChange={(selectedOption) => {
                setPipelineFilter(selectedOption.value);
                fetchStagesFromBitrix24(selectedOption.value, setStageOptions); // pipeline değişince stage'leri güncelle
                setStageFilter([]); // stage seçimini sıfırla
              }}
            />

            <label>Stage:</label>
            <Select
              options={stageOptions}
              value={stageOptions.filter(option => stageFilter.includes(option.value))}
              onChange={(selectedOptions) => setStageFilter(selectedOptions.map(option => option.value))}
              isMulti
            />
            <label className="exclude-label">
              <input type="checkbox" checked={excludeStage} onChange={() => setExcludeStage(!excludeStage)} />
              Exclude selected stages
            </label>

            <hr className="separator" />

            <label>Reason:</label>
            <Select
              options={reasonOptions}
              value={reasonOptions.filter(option => reasonFilter.includes(option.value))}
              onChange={(selectedOptions) => setReasonFilter(selectedOptions.map(option => option.value))}
              isMulti
            />
            <label>
              <input
                type="checkbox"
                checked={emptyReason}
                onChange={() => setEmptyReason(!emptyReason)}
              />
              Show only empty Reason
            </label>
            <label className="exclude-label">
              <input type="checkbox" checked={excludeReason} onChange={() => setExcludeReason(!excludeReason)} />
              Exclude selected reasons
            </label>

            <hr className="separator" />

            <label>Responsible:</label>
            <Select
              options={respOptions}
              value={respOptions.filter(option => respFilter.includes(option.value))}
              onChange={(selectedOptions) => setRespFilter(selectedOptions.map(option => option.value))}
              isMulti
            />
            <label className="exclude-label">
              <input type="checkbox" checked={excludeResp} onChange={() => setExcludeResp(!excludeResp)} />
              Exclude selected responsibles
            </label>

            <hr className="separator" />

            <label>Doctor:</label>
            <Select
              options={doctorOptions}
              value={doctorOptions.filter(option => doctorFilter.includes(option.value))}
              onChange={(selectedOptions) => setDoctorFilter(selectedOptions.map(option => option.value))}
              isMulti
            />
            <label>
              <input
                type="checkbox"
                checked={emptyDoctor}
                onChange={() => setEmptyDoctor(!emptyDoctor)}
              />
              Show only empty Doctor
            </label>
            <label className="exclude-label">
              <input type="checkbox" checked={excludeDoctor} onChange={() => setExcludeDoctor(!excludeDoctor)} />
              Exclude selected doctors
            </label>

            <hr className="separator" />

            <label>Language:</label>
            <Select
              options={langOptions}
              value={langOptions.filter(option => langFilter.includes(option.value))}
              onChange={(selectedOptions) => setLangFilter(selectedOptions.map(option => option.value))}
              isMulti
            />
            <label>
              <input
                type="checkbox"
                checked={emptyLang}
                onChange={() => setEmptyLang(!emptyLang)}
              />
              Show only empty Language
            </label>
            <label className="exclude-label">
              <input type="checkbox" checked={excludeLang} onChange={() => setExcludeLang(!excludeLang)} />
              Exclude selected languages
            </label>

            <hr className="separator" />

            <label>Treatment:</label>
            <Select
              options={treatmentOptions}
              value={treatmentOptions.filter(option => treatmentFilter.includes(option.value))}
              onChange={(selectedOptions) => setTreatmentFilter(selectedOptions.map(option => option.value))}
              isMulti
            />
            <label>
              <input
                type="checkbox"
                checked={emptyTreatment}
                onChange={() => setEmptyTreatment(!emptyTreatment)}
              />
              Show only empty Treatment
            </label>
            <label className="exclude-label">
              <input type="checkbox" checked={excludeTreatment} onChange={() => setExcludeTreatment(!excludeTreatment)} />
              Exclude selected treatments
            </label>

            <hr className="separator" />

            <label>Has Whatsapp:</label>
            <Select
              options={whatsappOptions}
              value={whatsappOptions.filter(option => whatsappFilter.includes(option.value))}
              onChange={(selectedOptions) => setWhatsappFilter(selectedOptions.map(option => option.value))}
              isMulti
            />
            <label>
              <input
                type="checkbox"
                checked={emptyWhatsapp}
                onChange={() => setEmptyWhatsapp(!emptyWhatsapp)}
              />
              Show only empty Whatsapp
            </label>

            <hr className="separator" />

            <label>Country:</label>
            <Select
              options={countryOptions}
              value={countryOptions.filter(option => countryFilter.includes(option.value))}
              onChange={(selectedOptions) => setCountryFilter(selectedOptions.map(option => option.value))}
              isMulti
            />
            <label>
              <input
                type="checkbox"
                checked={emptyCountry}
                onChange={() => setEmptyCountry(!emptyCountry)}
              />
              Show only empty Country
            </label>
            <label className="exclude-label">
              <input type="checkbox" checked={excludeCountry} onChange={() => setExcludeCountry(!excludeCountry)} />
              Exclude selected countries
            </label>

            <hr className="separator" />

            <button className="filter-button" onClick={handleFilterApply}>Apply Filter</button>
            <button className="clear-button" onClick={clearFilters}>Clear Filters</button>
          </div>
        </div>
        <div className="data-container">
          <div className="templates-container">
            <h2>Templates</h2>
            <div>
              <label>Select Template</label>
              <Select
                options={templateOptions}
                placeholder="Select Template"
                value={templateOptions.find(option => option.value === selectedTemplateId)}
                onChange={(selected) => setSelectedTemplateId(selected.value)}
              />
            </div>
            <p>
              {selectedTemplate ? selectedTemplate.content : 'No template selected'}
            </p>
            {selectedTemplate && selectedTemplate.example && (
              <p><strong>Example:</strong> {selectedTemplate.example}</p>
            )}
          </div>
          <div className="message-container">
            {selectedTemplate && (selectedTemplate.template_type === 'IMAGE' || selectedTemplate.template_type === 'VIDEO' || selectedTemplate.template_type === 'DOCUMENT' || selectedTemplate.template_type === 'AUDIO' || selectedTemplate.template_type === 'FILE') && (
              <div>
                <label>Media URL:</label>
                <input
                  type="text"
                  className='message-input'
                  placeholder="https://example.com/media.jpg"
                  value={mediaUrl}
                  onChange={(e) => setMediaUrl(e.target.value)}
                />
              </div>
            )}
            {parameterCount > 0 && (
              <div>
                {Array.from({ length: parameterCount }, (_, index) => (
                  <div key={index}>
                    <label>{`Template Value ${index + 1}:`}</label>
                    <textarea
                      className='message-input'
                      placeholder={`Enter value for {{${index + 1}}}`}
                      value={templateValues[index] || ''}
                      onChange={(e) => handleTemplateValueChange(index, e.target.value)}
                    />
                  </div>
                ))}
              </div>
            )}
            <button className="send-button" onClick={sendMessageToAll} disabled={loading}>Send Message to All</button>
          </div>
          <div className="assign-section">
            <label>
              <input type="checkbox" checked={bulkAssign} onChange={() => setBulkAssign(!bulkAssign)} />
              Enable Bulk Assignment
            </label>
            {bulkAssign && (
              <Select
                options={respOptions}
                isMulti
                onChange={setRespFilter}
                placeholder="Select Responsible Users"
              />
            )}
            <button className="assign-button" onClick={assignDealsToResponsibles}>Assign Deals</button>
          </div>
          <h3>Total: {filteredDeals.length}</h3>
          <div className="pagination">
            <button className="pagination-button" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
              Prev
            </button>
            <span>Page {currentPage} of {Math.ceil(filteredDeals.length / itemsPerPage)}</span>
            <button className="pagination-button" onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(filteredDeals.length / itemsPerPage)))}
              disabled={currentPage === Math.ceil(filteredDeals.length / itemsPerPage)}>
              Next
            </button>
          </div>
          <div className="loader-container">
            {loading ? (
              <ThreeDots color="#00BFFF" height={50} width={50} />
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Deal Name</th>
                    <th>Created Date</th>
                    <th>Responsible</th>
                    <th>Stage</th>
                    <th>Doctor</th>
                    <th>Language</th>
                    <th>Treatment</th>
                    <th>Country</th>
                    <th>Reason</th>
                    <th>Phone</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedDeals.map((deal, index) => {
                    const contact = fetchedContacts.find(contact => contact.ID === deal.CONTACT_ID);
                    const destination = contact && contact.PHONE && contact.PHONE.length > 0 ? contact.PHONE[0].VALUE : '';
                    const stageLabel = stageOptions.find(option => option.value === deal.STAGE_ID)?.label || '';
                    const doctorName = doctorOptions.find(option => option.value === deal.UF_CRM_1614780869409)?.label || '';
                    const langName = langOptions.find(option => option.value === deal.UF_CRM_1645705625)?.label || '';

                    const reasonArray = Array.isArray(deal.UF_CRM_1610457905592) ? deal.UF_CRM_1610457905592 : [];
                    const reasonNames = reasonArray
                      .map(value => {
                        const reason = reasonOptions.find(option => String(option.value) === String(value));
                        return reason?.label || '';
                      })
                      .filter(label => label)
                      .join(', ');

                    const createDate = deal.DATE_CREATE.substring(0, 10);
                    const respName = respOptions.find(option => option.value === deal.ASSIGNED_BY_ID)?.label || '';
                    const treatmentName = treatmentOptions.find(option => option.value === deal.UF_CRM_1646137196)?.label || '';

                    const countryId = contact?.UF_CRM_1591879765;
                    const countryLabel = countryOptions.find(option => option.value === countryId?.toString())?.label || '';

                    return (
                      <tr key={deal.ID}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{deal.TITLE}</td>
                        <td>{createDate}</td>
                        <td>{respName}</td>
                        <td>{stageLabel}</td>
                        <td>{doctorName}</td>
                        <td>{langName}</td>
                        <td>{treatmentName}</td>
                        <td>{countryLabel}</td>
                        <td>{reasonNames}</td>
                        <td>{destination}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default App;